import { createFileRoute } from '@tanstack/react-router';
import { RelatorioEstoqueSaldo } from '@/features/relatorio/page/estoque/saldos-em-estoque/RelatorioEstoqueSaldo';

export const Route = createFileRoute('/a/relatorio/estoque/saldos-em-estoque')({
    component: RelatorioEstoqueSaldo,
});
